import { ConfigProvider, Space, Switch, Typography } from 'antd'
import { EXPLORER_BORDER_GRAY_LOW_OPACITY } from 'features/drilldown/colors'
import { PropertyValueEditor } from 'features/drilldown/components/ontology/PropertyValueEditor'
import { useFieldType } from 'features/drilldown/panels/global/bulkEdit/hooks/useFieldType'
import { DrilldownFieldType } from 'features/drilldown/rolodex/ontology/ontologyTypes'
import { FC } from 'react'
import CantileverTheme from 'styles/cantileverTheme'

const { Text } = Typography

interface ValueConfigurationStepProps {
  selectedType: string
  isWithinEntryCountLimit: boolean
  selectedField: string
  isEditingCustomProperty: boolean
  customPropertyName: string
  customPropertyType: DrilldownFieldType
  shouldPrefillValues: boolean
  prefillValue: string
  onShouldPrefillValuesChange: (value: boolean) => void
  onPrefillValueChange: (value: string) => void
}

export const ValueConfigurationStep: FC<ValueConfigurationStepProps> = ({
  selectedField,
  isEditingCustomProperty,
  customPropertyType,
  shouldPrefillValues,
  prefillValue,
  onShouldPrefillValuesChange,
  onPrefillValueChange,
}) => {
  const selectedFieldType = useFieldType({
    isEditingCustomProperty,
    customPropertyType,
    selectedField,
  })

  return (
    <Space direction='vertical' style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '12px',
          border: `1px solid ${EXPLORER_BORDER_GRAY_LOW_OPACITY}`,
          borderRadius: '6px',
        }}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: CantileverTheme.colors.blue['500_base'],
            },
          }}>
          <Switch
            checked={shouldPrefillValues}
            onChange={onShouldPrefillValuesChange}
            size='small'
          />
        </ConfigProvider>
        <Text>Use prefilled values</Text>
        <Text type='secondary' style={{ margin: 0, fontSize: '12px' }}>
          When enabled, all entries will be prefilled with a global value. When
          disabled, entries default to their current values.
        </Text>
      </div>
      {shouldPrefillValues && (
        <PropertyValueEditor
          type={selectedFieldType}
          value={prefillValue}
          onChange={onPrefillValueChange}
          fieldKey={selectedField}
          size='middle'
          rows={
            selectedFieldType === 'object' || selectedFieldType === 'array'
              ? 6
              : 3
          }
          style={{ width: '100%' }}
        />
      )}
    </Space>
  )
}
